import { useState, useEffect } from 'react'
import store from 'stores/campaign_summary_amounts_store'

const TotalPrintsCell = (props) => {
  const { pdfPagesCount, elementId, setHiddenFields } = props
  const [totalPrints, updateTotalPrints] = useState(props.totalPrints)

  useEffect(() => {
    const listener = store.addListener(`TotalWasChanged-${elementId}`, () => {
      let totalPrints = store.totalPrintsFor(elementId, pdfPagesCount)
      setHiddenFields({ elementId, totalPrints })
      updateTotalPrints(totalPrints)
    })
    return () => listener.remove()
  }, [])

  return (
    <div className="row">
      <div className="col-12 text-center">{totalPrints}</div>
    </div>
  )
}

export default TotalPrintsCell
